/**
 * The self-checkout kiosk (the customer reads it) and the handheld terminal
 * (price, goods in, the count).
 */
export const kiosk = {
  'kiosk.onlyInStock': '{name} — მხოლოდ {n} {unit} არის მარაგში',
  'kiosk.outOfStock': '{name} — მარაგი ამოიწურა',
  'kiosk.wrongPin': 'PIN არასწორია',
  'kiosk.exitAria': 'კიოსკიდან გასვლა (ადმინი)',
  'kiosk.closedTitle': 'სალარო ჯერ დაკეტილია',
  'kiosk.closedBody': 'გთხოვთ მიმართოთ თანამშრომელს',
  'kiosk.welcome': 'მოგესალმებით! 👋',
  'kiosk.scanPrompt': 'დაასკანერეთ პროდუქტის შტრიხკოდი',
  'kiosk.cart': 'თქვენი კალათა',
  'kiosk.cartSub': '{n} პროდუქტი · განაგრძეთ სკანირება',
  'kiosk.empty': 'კალათა ცარიელია — დაასკანერეთ პროდუქტი',
  'kiosk.forgot': 'დაგავიწყდათ?',
  'kiosk.pay': 'გადახდა — {sum}',
  'kiosk.toPay': 'გადასახდელი',
  'kiosk.byCash': 'ნაღდით',
  'kiosk.tapCard': 'მიადეთ ბარათი ტერმინალს',
  'kiosk.terminalLine': '{bank} ტერმინალი · {sum}',
  'kiosk.giveCash': 'გადაეცით თანხა თანამშრომელს',
  'kiosk.staffConfirms': 'გადახდის დასრულების შემდეგ თანამშრომელი დაადასტურებს',
  'kiosk.saving': 'ინახება...',
  'kiosk.paidDone': 'გადახდა დასრულდა',
  'kiosk.thanks': 'გმადლობთ! 🙏',
  'kiosk.paid': 'გადახდილია {sum}',
  'kiosk.goodDay': 'გისურვებთ წარმატებულ დღეს — {shop}',
  'kiosk.scanTitle': 'დაასკანერეთ პროდუქტი',
  'kiosk.adminPin': 'ადმინის PIN',

  'terminal.price': 'ფასი',
  'terminal.receive': 'მიღება',
  'terminal.count': 'თვლა',
  'terminal.countHint': 'დაასკანერე თაროზე მდგარი საქონელი და ჩაწერე რამდენია',
  'terminal.countStart': 'თვლის დაწყება',
  'terminal.setupTitle': 'ტერმინალის სკანერის დაყენება',
  'terminal.setupIntro': 'სკანერის პარამეტრებში (Scanner / Scan settings / DataWedge) აირჩიე {kbd} და ბოლოში {enter}:',
  'terminal.keyboardMode': 'კლავიატურის რეჟიმი',
  'terminal.zebra': '— DataWedge → Keystroke output: ჩართული, „Send ENTER key".',
  'terminal.sunmi': '— Scanner → Output: „Simulate keystrokes" ან „Direct fill", ბოლოში Enter.',
  'terminal.setupNote': 'ეს ველი ორივე რეჟიმს იჭერს. თუ კოდი მაინც არ ჩნდება, კლავიატურის ღილაკით ჩაწერე ხელით და მოგვწერე მოდელი.',
  'terminal.priceHint': 'დაასკანერე პროდუქტი — გამოჩნდება ფასი და მარაგი',
  'terminal.stock': 'მარაგი',
  'terminal.allBranches': 'ყველა ფილიალი',
  'terminal.unknownCode': 'ეს კოდი ბაზაში არ არის',
  'terminal.pendingFirst': '„{name}" არ დამატებულა — ჯერ ის დაამატე ან გააუქმე',
  'terminal.receivePh': 'დაასკანერე მიღებული საქონელი',
  'terminal.toBranch': 'მარაგი ემატება ფილიალს: {branch}',
  'terminal.unknownAdd': 'ეს კოდი ბაზაში არ არის — ჯერ საწყობში დაამატე',
  'terminal.nowInStock': 'ახლა მარაგშია {qty} · ფასი {price}',
  'terminal.minusOne': 'ერთით ნაკლები',
  'terminal.plusOne': 'ერთით მეტი',
  'terminal.qty': 'რაოდენობა',
  'terminal.looksLikeBarcode': 'ეს შტრიხკოდს ჰგავს და არა რაოდენობას — გაასწორე',
  'terminal.unitCost': 'თვითღირებულება (1 ცალი)',
  'terminal.addStock': 'მარაგში დამატება',
  'terminal.receiveHint': 'დაასკანერე პროდუქტი. იგივე კოდის ხელახლა დასკანერება რაოდენობას ერთით ზრდის.',
  'terminal.justReceived': 'ახლა მიღებული',
  'terminal.scanPh': 'დაასკანერე ან ჩაწერე კოდი',
  'terminal.barcode': 'შტრიხკოდი',
  'terminal.search': 'ძებნა',
  'terminal.hideKb': 'კლავიატურის დამალვა',
  'terminal.typeCode': 'კოდის ხელით ჩაწერა',
  'terminal.cameraContinuous': 'დაასკანერე — იგივე კოდი კიდევ ერთს უმატებს',
} as const
